module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_background"
  }, [_c('div', {
    staticClass: "container_right_info"
  }, [_c('div', {
    staticClass: "clearfix tb_padding"
  }, [_c('div', {
    staticClass: "container_box"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("手机号码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.telephone))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开发者姓名：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.devName))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("证件类型及编号：")]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.developerInfo.cardType) + ")" + _vm._s(_vm.developerInfo.cardNo))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("证件照片：")]), _vm._v(" "), _c('div', {
    staticClass: "example id_card_photo inline-block",
    attrs: {
      "id": "images"
    }
  }, [_c('img', {
    staticClass: "zoomify img_default",
    attrs: {
      "src": _vm.echoImg,
      "alt": "",
      "title": "证件照",
      "id": "imgz",
      "width": "234px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "example id_card_photo inline-block",
    attrs: {
      "id": "imagesf"
    }
  }, [_c('img', {
    staticClass: "zoomify img_default",
    attrs: {
      "src": _vm.echoImg1,
      "alt": "",
      "title": "证件照",
      "id": "imgf",
      "width": "234px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.bankType))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开户支行：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("银行卡号：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.cardNo))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开户名：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.cardUsername))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.sites))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.email))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.telephone))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("其他手机或电话号码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.otherphone))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("QQ：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.qq))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("官网地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.developerInfo.blogUrl))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("结算方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("联系方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("联系地址：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("电子邮箱：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("手机号码：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-53c654f0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/developer_data.vue
// module id = 1260
// module chunks = 1